module.exports = __webpack_public_path__ + "static/media/billing-address-tooltip.5330f3e7.png";